// MetaContext.tsx
import React, { createContext, useContext, useState } from 'react';
import { Helmet } from 'react-helmet';

interface MetaData {
  title?: string;
  description?: string;
  keywords?: string;
}

const MetaContext = createContext<{
  meta: MetaData;
  setMeta: React.Dispatch<React.SetStateAction<MetaData>>;
}>({
  meta: {},
  setMeta: () => {},
});

export const MetaProvider = ({ children }: { children: React.ReactNode }) => {
  const [meta, setMeta] = useState<MetaData>({});

  return (
    <MetaContext.Provider value={{ meta, setMeta }}>
      {/* Helmet lives here, so it's always rendered */}
      <Helmet>
        {meta.title && <title>{meta.title}</title>}
        {meta.description && <meta name="description" content={meta.description} />}
        {meta.keywords && <meta name="keywords" content={meta.keywords} />}
      </Helmet>
      {children}
    </MetaContext.Provider>
  );
};

export const useMeta = () => useContext(MetaContext);
